<header class="header">
  <div class="w-100 d-flex align-items-center gap-16">
    <div class="sm-hide" *ngIf="sessionService.isLoggedIn$ | async">
      <app-button
        variant="ghost"
        size="icon"
        (click)="sidebarService.toggleMenu()"
      >
        <app-icon class="header__menu">menu</app-icon>
      </app-button>
    </div>
    <div class="w-100 d-flex justify-content-between">
      <ng-content select="[leftColumn]"></ng-content>
      <h2 class="header__title">
        <ng-content select="[centerColumn]"></ng-content>
      </h2>
      <ng-content select="[rightColumn]"></ng-content>
    </div>
  </div>
</header>
